
import '../assets/scss/style.scss';
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
    name: "SignlePriceGrid"
})
